/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useCallback, useContext, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { colors, device } from './GlobalStyles';
import { siteContext } from '../../layouts/SiteContextProvider';
import { ReactComponent as Phone } from '../../images/svgs/mobile-blue.svg';
import { ReactComponent as Arrow } from '../../images/svgs/arrow-down-black.svg';
import { ReactComponent as Logo } from '../../images/svgs/logo.svg';
import { contact } from '../../contact';
import { navMenu } from './navMenu';
import { ButtonPrimary } from './StyledComponents';
import { ReactComponent as Mobile } from '../../images/svgs/mobile-white.svg';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

interface Props {
    active: boolean;
}

const MobileNav = styled.div<Props>`
    height: 100px;
    box-shadow: ${({ active }) => (active ? 'none' : 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px')};
    display: flex;
    transition: box-shadow 0.2s ease-in;
    transition: background-color 0.2s ease-in;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    background: ${({ active }) => (active ? 'none' : 'white')};
    z-index: 10;
    min-width: 100vw;

    .burger-phone-container {
        display: flex;
    }
    .line-one {
        transition: 0.2s cubic-bezier(0.1, 0.7, 0.6, 0.9);
        position: relative;
        top: ${({ active }) => (!active ? '0' : '5px')};
        transform: ${({ active }) => (!active ? 'rotate(0%)' : 'rotate(45deg)')};
        width: ${({ active }) => (!active ? '23px' : '24px')};
    }
    .line-two {
        width: ${({ active }) => (!active ? '17px' : '0px')};
        transition: 0.5s cubic-bezier(0.1, 0.7, 0.6, 0.9);
    }
    .line-three {
        transition: 0.2s cubic-bezier(0.1, 0.7, 0.6, 0.9);
        position: relative;
        bottom: ${({ active }) => (!active ? '0' : '9px')};
        transform: ${({ active }) => (!active ? 'rotate(0%)' : 'rotate(-45deg)')};
        width: ${({ active }) => (!active ? '23px' : '24px')};
    }
    @media ${device.laptop} {
        display: none;
        height: 140px;
        margin: 15px 32px;
        .burger-phone-container {
            display: none;
        }
    }
`;

const MobileMenu = styled.div<Props>`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    z-index: 2;
    height: 100vh;
    background: ${colors.yellow1};
    display: flex;
    flex-direction: row;
    justify-content: start;
    padding: 160px 100px;
    transition: transform 0.2s cubic-bezier(0.1, 0.7, 0.6, 0.9);
    transform: ${({ active }) => (active ? 'translateX(0%)' : 'translateX(100%)')};
    .make-appt-mobile {
        position: absolute;
        bottom: 70px;
        border-radius: 200px;
        button {
            color: ${colors.white};
            box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
        }
        background: ${colors.yellow4};
    }
    ul {
        position: relative;
        left: 10px;
        top: -35px;
        padding: 0;
        list-style: none;
        svg {
            margin-left: 8px;
            fill: ${colors.blue3};
        }
        button {
            font-size: 18px;
            font-weight: bold;
            color: ${colors.blue3};
        }
    }
    li,
    a {
        margin: 16px 0px;
        font-weight: 700;
    }
    a {
        font-size: 18px;
        color: ${colors.blue3};
        text-decoration: none;
    }
    button {
        background: none;
        border: none;
    }
    .back-button {
        position: absolute;
        align-items: center;
        display: flex;
        justify-content: start;
        left: -30px;
        top: -40px;
        text-decoration: underline;
        font-size: 18px;
        font-weight: bold;
        color: ${colors.blue3};
        p {
            color: ${colors.blue3};
        }
        a {
            color: ${colors.blue2};
        }
        svg {
            margin-right: 8px;
            fill: ${colors.blue3};
            transform: rotate(90deg);
        }
    }
    @media ${device.laptop} {
        display: none;
    }
`;

const StyledNav = styled.nav``;

const Burger = styled.div<Props>`
    background: none;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: end;
    border: none;
    background: none;
    margin-left: 32px;
    div {
        height: 3px;
        background: ${colors.yellow4};
    }
    .line-one {
        margin-bottom: 4px;
        width: 25px;
    }
    .line-two {
        margin-bottom: 4px;
        width: 18px;
    }
    .line-three {
        width: 20px;
    }
    @media ${device.laptop} {
        display: none;
    }
`;

interface NewProps {
    active: boolean;
    scroll: boolean;
}

const DesktopNav = styled.div<NewProps>`
    display: none;
    @media ${device.laptop} {
        display: flex;
        transition: box-shadow 0.2s ease-in;
        transition: background-color 0.2s ease-in;
        box-shadow: ${({ scroll }) =>
            !scroll ? 'none' : 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'};
        background: ${({ scroll }) => (scroll ? `${colors.white}` : '')};
        align-items: center;
        position: fixed;
        top: 0;
        min-width: 100vw;
        z-index: 4;
        margin: 0px 0px 0px;
        padding: 16px 54px;
        justify-content: space-between;
        .main-menu {
            display: flex;
            width: 520px;
            justify-content: space-between;
            list-style: none;
            > li {
                cursor: pointer;
                display: flex;
                align-items: center;
                transition: 0.2s ease-in;
                svg {
                    fill: #353633;
                    margin-left: 10px;
                    transition: 0.2s ease-in;
                }
                &:hover {
                    svg {
                        transform: rotate(180deg);
                    }
                }
            }
            > li {
                display: inline-block;
                position: relative;
            }
            > li:hover:after {
                transform: scaleX(1);
                transform-origin: left right;
            }
            > li:after {
                content: '';
                position: absolute;
                width: 50%;
                transform: scaleX(0);
                height: 2px;
                bottom: -3px;
                left: 25%;
                background-color: ${colors.yellow3};
                transform-origin: left right;
                transition: transform 0.25s cubic-bezier(0.33, 1, 0.68, 1);
            }
        }

        .desktop-buttons {
            display: flex;
            button {
                margin-right: 20px;
            }
            .desktop-mobile {
                background: ${colors.yellow3};
                padding: 15px;
                display: flex;
                border-radius: 100px;
                border: 2px solid ${colors.yellow3};
                svg {
                    stroke: ${colors.white};
                    fill: ${colors.white};
                }
            }

            .desktop-mobile:hover {
                background: none;
                transition: 0.2s ease-in;
                svg {
                    transition: 0.2s ease-in;
                    stroke: ${colors.yellow3};
                    fill: ${colors.yellow3};
                }
            }
        }
        .logo-desktop {
            width: 170px;
        }
    }
    @media ${device.laptopL} {
        .logo-desktop {
            width: 195px;
        }
        .main-menu {
            width: 620px;
        }
        .desktop-buttons {
            display: flex;
            button {
                margin-right: 20px;
            }
            .desktop-mobile {
                background: ${colors.yellow3};
                padding: 15px;
                display: flex;
                border-radius: 100px;
                border: 2px solid ${colors.yellow3};
                svg {
                    stroke: ${colors.white};
                    fill: ${colors.white};
                }
            }
        }
    }
`;

const DesktopMenu = styled.ul`
    position: absolute;
    display: flex;
    flex-direction: column;
    background: white;
    max-width: 283px;
    min-width: 283px;
    opacity: 1;
    z-index: 2;
    background: #fcfcfc;
    box-shadow: 0px 51px 125px rgba(109, 106, 93, 0.09),
        0px 18.5323px 39.5627px rgba(109, 106, 93, 0.0393285),
        0px 8.27833px 15.9688px rgba(109, 106, 93, 0.0425114),
        0px 4.0063px 6.7726px rgba(109, 106, 93, 0.0304631);
    border-radius: 15px;
    list-style: none;
    left: -16px;
    top: 50px;
    a {
        color: black;
        text-decoration: none;
    }
    li {
        transition: 0.2s ease-in;
        width: 100%;
        z-index: 0;
        padding: 8px 16px;
        cursor: pointer;
        &:hover {
            background: #d8f0fe;
        }
    }
    li:first-of-type {
        border-radius: 15px 15px 0 0;
        padding-top: 16px;
        cursor: pointer;
    }
    li:last-of-type {
        border-radius: 0px 0px 15px 15px;
        padding-bottom: 16px;
        cursor: pointer;
    }
    &:hover {
        opacity: 1;
    }
`;

type MenuType = {
    name: string;
    path: string;
};

const debounce = (func: { (): void; apply?: any }, ms: number) => {
    let timer: any;
    return (...args: any) => {
        if (!timer) {
            timer = setTimeout(() => {
                timer = undefined;
                func.apply(this, args);
            }, ms);
        }
    };
};

export const Nav = () => {
    const { active, setActive } = useContext(siteContext);
    const [menuName, setMenuName] = useState<string | null>(null);
    const [menuState, setMenuState] = useState<MenuType[] | null>(null);
    const isSSR = typeof window === 'undefined';
    const [scroll, setScroll] = useState(false);
    const [position, setPosition] = useState(isSSR ? 0 : window.scrollY);

    const debounceMs = 200;

    const onScroll = useCallback(
        debounce(() => setPosition(window.scrollY), 50),
        [debounceMs, setPosition]
    );

    useEffect(() => {
        setScroll(true);
    }, []);

    useEffect(() => {
        if (isSSR) return;
        window.addEventListener('scroll', onScroll);
        if (position > 100) {
            setScroll(true);
        } else {
            setScroll(false);
        }
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [position]);

    return (
        <StyledNav>
            <MobileNav active={active} className="container">
                <Link aria-label="Clermont Logo" to="/">
                    <StaticImage
                        src="../../images/logo.png"
                        alt="clermont kids dentistry & orthodontics"
                        width={153}
                        height={45}
                        quality={100}
                        loading="eager"
                    />
                </Link>
                <div className="burger-phone-container">
                    <a aria-label="call Clermont Kids Dental" href={`tel:${contact.phone}`}>
                        <Phone>
                            <title>Mobile Phone</title>
                        </Phone>
                    </a>
                    <Burger
                        onClick={() => {
                            setActive(active => !active);
                        }}
                        active={active}
                    >
                        <div className="line-one"></div>
                        <div className="line-two"></div>
                        <div className="line-three"></div>
                    </Burger>
                </div>
            </MobileNav>
            <MobileMenu active={active}>
                <ul>
                    {!menuState &&
                        navMenu.map(({ menu, name }) => {
                            return (
                                <li key={name}>
                                    <button
                                        style={{ color: `${colors.blue3}` }}
                                        onClick={() => {
                                            setMenuName(name);
                                            setMenuState(menu);
                                        }}
                                    >
                                        {name}
                                        <Arrow />
                                    </button>
                                </li>
                            );
                        })}
                </ul>
                {
                    <ul>
                        {menuState && (
                            <button
                                onClick={() => {
                                    setMenuState(null);
                                    setMenuName('');
                                }}
                                className="back-button"
                            >
                                <Arrow />
                                <p>{menuName}</p>
                            </button>
                        )}
                        {menuState &&
                            menuName &&
                            menuState.map(subItems => {
                                return (
                                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                                    <li
                                        onClick={() => {
                                            setActive(false);
                                        }}
                                        key={subItems.name}
                                    >
                                        <Link to={subItems.path}>{subItems.name}</Link>
                                    </li>
                                );
                            })}
                    </ul>
                }

                <a
                    className="make-appt-mobile"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://patientportal-cs4.carestack.com/?dn=ck&ln=1/#/online-appointments"
                >
                    <ButtonPrimary>Make an Appointment</ButtonPrimary>
                </a>
            </MobileMenu>
            <DesktopNav scroll={scroll} className="container" active={active}>
                <Link to="/">
                    <Logo className="logo-desktop" />
                </Link>
                <ul className="main-menu">
                    {navMenu.map(({ menu, name, path }) => {
                        return (
                            <li
                                onMouseEnter={() => {
                                    setActive(true);
                                    setMenuName(name);
                                    setMenuState(menu);
                                }}
                                key={name}
                            >
                                <Link onClick={() => setActive(false)} to={path}>
                                    {name}
                                    <Arrow />
                                </Link>
                                {
                                    <DesktopMenu>
                                        {active &&
                                            menuName === name &&
                                            menuState.map(subItems => {
                                                return (
                                                    <li key={subItems.name}>
                                                        <Link
                                                            onClick={() => setActive(false)}
                                                            to={subItems.path}
                                                        >
                                                            {subItems.name}
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                    </DesktopMenu>
                                }
                            </li>
                        );
                    })}
                </ul>
                <div className="desktop-buttons">
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://patientportal-cs4.carestack.com/?dn=ck&ln=1/#/online-appointments"
                    >
                        <ButtonPrimary>Make an Appointment</ButtonPrimary>
                    </a>
                    <a href={`tel:${contact.phone}`} className="desktop-mobile">
                        <Mobile />
                    </a>
                </div>
            </DesktopNav>
        </StyledNav>
    );
};
